import React, { useState } from 'react'
import PropTypes from 'prop-types'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import styled, { css } from 'styled-components'
import TrackingHOC from '../../hocs/TrackingHOC'
import { useAppContext } from '../../containers/App/Context'

const v4 = css`
  --h5: var(--base);
  .body {
    background-color: unset;
    color: var(--clr-accent-to-white);
  }
`

const ThumbsIcon = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 1.2rem;
  margin-left: 10px;
  margin-right: 3px;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  .body {
    color: var(--clr-grey-5-to-white);
    background-color: var(--clr-white-to-text);
    padding: 10px 10px 10px 20px;
    margin-top: 15px;
    font-size: var(--h5);
    font-weight: bold;
    border-radius: 5px;
    max-width: 340px;
    min-height: var(--button-height);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span {
    margin-left: 16px;
    margin-right: 8px;
    font-size: 1.7em;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
  ${props => props.version === 'v4' && v4}
`

const QuickFeedback = ({
  track,
  createUserEvent,
  type,
  language,
  contentId
}) => {
  const [clicked, setClicked] = useState(false)
  const { versionKey: version } = useAppContext()

  const clickHandler = (helpful, contentId) => {
    setClicked(true)
    track(
      `QuickFeedback ${type}`,
      helpful ? 'Positive' : 'Negative',
      `${contentId}`
    )
    createUserEvent({
      category: type,
      data: {
        action: 'QuickFeedback',
        target: contentId,
        feedback: { helpful: helpful }
      }
    })
  }

  const translated = messages[language]

  return (
    <Wrapper version={version}>
      <div tabIndex="1" id="quick-feedback">
        {clicked ? (
          <div aria-label={translated['thanks']} className="body">
            {translated['thanks']}
            <div className="buttons">
              <span className="fa fa-check" />
            </div>
          </div>
        ) : (
          <div className="body">
            {translated[type]['helpful']}
            <ThumbsIcon
              onClick={() => clickHandler(true, contentId)}
              className="fa fa-thumbs-o-up"
              aria-label="Helpful"
            />
            <ThumbsIcon
              onClick={() => clickHandler(false, contentId)}
              className="fa fa-thumbs-o-down"
              aria-label="Unhelpful"
            />
          </div>
        )}
      </div>
    </Wrapper>
  )
}
QuickFeedback.propTypes = {
  type: PropTypes.string.isRequired,
  contentId: PropTypes.number.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  track: PropTypes.func,
  language: PropTypes.string
}

export default LanguageProvider(TrackingHOC(QuickFeedback))



// WEBPACK FOOTER //
// ./src/components/QuickFeedback/QuickFeedback.js